export const resetDocumentTitle = () => {
  window.document.title = "TALTO";
};
